import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { YMInitializer } from 'react-yandex-metrika';
import './App.css';
import { Blog } from "./pages/Blog";
import { Dashboard } from "./pages/Dashboard";
import { Game } from "./pages/Game";
import { Main } from "./pages/Main";

function App() {

  return (
    <div>
      <YMInitializer accounts={[87063484]} options={{ webvisor: true }} version="2" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/game" element={<Game />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );

}

export default App;
